/* eslint-disable */
import React, { Fragment, useState, useEffect } from 'react';
import cn from 'classnames';
import { _, isEmpty } from 'lodash';
import styles from './orders.module.scss';
import { LABEL } from '../../veriables';
import findIndex from 'lodash/findIndex';
import find from 'lodash/find';
import { getObjectValue } from '@utility/utills';
import Modal from '@components/common/Modal';
import { Formik, Form } from 'formik';
import KeyboardInput from '@components/common/formElements/KeyboardInput/keyboardInput';
import OrderItemDetail from '@components/OrderItemDetail';
import WrapperComponent from './WrapperComponent';

const DesktopMenuItems = (props) => {
  const {
    menuItem,
    addToCart,
    cartItemsInfo,
    menuIndex,
    searchString,
    auth,
  } = props;

  const [btnColor, setBtnColor] = useState();
  const [isOpenPricePopup, setIsOpenPricePopup] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState({});
  const [info, setInfo] = useState(false);

  const validatePrice = (val) => {
    const error = {};
    if (isEmpty(val.price)) {
      error.price = 'Enter Price';
    }
    return error;
  };

  const submitPrice = (val) => {
    const dataToSend = { ...selectedMenuItem, price: val.price }
    handleAddToCart(dataToSend);
    setIsOpenPricePopup(false);
  };

  let subMenuItemList = [];
  if (searchString === '') {
    subMenuItemList = _.sortBy(_.chain(menuItem.filter((e) => !e.linkedItem)).groupBy('groupName').map((value, key) => ({ groupName: key, items: value, index: _.minBy(value, (o) => o.index).index })).value(), (d) => d.index);
  } else {
    const subMenuList = _.orderBy(menuItem.filter((e) => !e.linkedItem), [(menu) => menu?.menuItem?.name?.toLowerCase()], ['asc']);
    subMenuItemList.push({ items: subMenuList });
  }

  useEffect(() => {
    if (props.menusList[menuIndex]) {
      if (window.sessionStorage.getItem('menuTypeId') && find(props.menusList[menuIndex].screens, { id: Number(window.sessionStorage.getItem('menuTypeId')) })) {
        const arrayIndex = findIndex(props.menusList[menuIndex].screens, ['id', Number(window.sessionStorage.getItem('menuTypeId'))]);
        if (arrayIndex >= 0) {
          setBtnColor(props.menusList[menuIndex].screens[arrayIndex].buttonColor);
        }
      } else {
        const arrayIndex = findIndex(props.menusList[menuIndex].screens, ['id', ((props.menusList[menuIndex].screens[0] && props.menusList[menuIndex].screens[0].id) || [])]);
        if (arrayIndex >= 0) {
          setBtnColor(props.menusList[menuIndex].screens[arrayIndex].buttonColor);
        }
      }
    }
  // }, [props.menusList, menuIndex, subMenuItemList]);
  }, [subMenuItemList]);

  const geItemQuantity = (cart) => {
    let count = 0;
    cart.forEach((item) => {
      count += item.quantity;
    });
    return count;
  };
  
  const getCartInfoForLinkedItems = (itemsList) => {
    let count = 0;
    (itemsList || []).forEach((linkedMenuItem) => {
      if (cartItemsInfo[linkedMenuItem.linkedMenuItemId]) {
        count += geItemQuantity(cartItemsInfo[linkedMenuItem.linkedMenuItemId]);
      }
    });
    return count;
  };

  const handleAddToCart = (data) => {
    if (cartItemsInfo[data.menuItemId] || (getObjectValue(() => data.menuItem.linkType, 0) === 1 && getCartInfoForLinkedItems(data.menuItem.links) > 0)) {
      if (data.menuItem.openPrice) {
        addToCart(data.menuItemId, data.menuTypeId, 0, Number(data.price));
      } else {
        addToCart(data.menuItemId, data.menuTypeId, 0);
      }
    } else if (data.menuItem && !data.menuItem.outOfStock) {
      if (data.menuItem.openPrice) {
        addToCart(data.menuItemId, data.menuTypeId, 1, Number(data.price));
      } else {
        addToCart(data.menuItemId, data.menuTypeId, 1);
      }
    }
  };

  const openPricePopUp = (data) => {
    setIsOpenPricePopup(true);
    setSelectedMenuItem(data);
  };

  return (
    <Fragment>
      <div className={cn('p-0 h-100', styles.menuItems, 'w-100')} style={{ paddingBottom: `${Math.max(props.footerHeight, 0)}px` }}>
        <WrapperComponent openPricePopUp={openPricePopUp} searchString={searchString} menuItem={menuItem} handleAddToCart={handleAddToCart} subMenuItemList={subMenuItemList} auth={auth} btnColor={btnColor} />
      </div>
      {info && (
        <OrderItemDetail
          info={info}
          setInfo={setInfo}
          itemInfo={selectedMenuItem}
        />
      )}
      <Modal
        isOpen={isOpenPricePopup}
        loading={props.loading}
      >
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div className="px-1 text-right">
            <div className="" role="presentation" onClick={() => { setIsOpenPricePopup(false) }}>
              <i className="fa fa-times fs-24" aria-hidden="true" />
            </div>
          </div>
          <Formik
            initialValues={{ price: '' }}
            onSubmit={submitPrice}
            validate={validatePrice}
          >
            {() => {
              return (
                <Form>
                  {isOpenPricePopup && (
                    <KeyboardInput
                      name="price"
                      type="number"
                      erase
                      isDecimal
                      placeholder="Enter Price"
                      isOpen={isOpenPricePopup}
                      customClass="mt-2"
                    />
                  )}
                  <button
                    className={cn('w-100 mt-2 btn btn-primary od-btn-primary')}
                    type="submit"
                    style={{ height: '10vh' }}
                  >
                  <div className="fs-18">{LABEL().ADD_TO_CART}</div>
                  </button>
                </Form>
              );
            }}
          </Formik>
        </div>
      </Modal>
    </Fragment>
  );
};

export default DesktopMenuItems;
